export default function TwoHandsClock({ hour1, hour2, size = 200 }: { hour1: number, hour2: number, size: number }) {
    //center of clock
    const cx = size / 2;
    const cy = size / 2;

    const hourToAngle = (hour: number) => (360 / 12) * ((hour ?? 0) % 12); //%12 because 12%12 = 0, also this works for 24 hr time

    //Given a starting point (center of clock), length, and and angle, 
    // you can use the formula: x2 = x1 + L * cos(θ) and y2 = y1 + L * sin(θ) to get the second point to draw the hand
    const getSecondPoint = (cx: number, cy: number, r: number, angleDeg: number) => {
        const angleRad = ((angleDeg - 90) * Math.PI) / 180.0;
        return {
            x: cx + r * Math.cos(angleRad),
            y: cy + r * Math.sin(angleRad),
        };
    };

    const angle1 = hourToAngle(hour1);
    const angle2 = hourToAngle(hour2);

    //we can calculate the arc between them, 
    // convert them to radians first (since thats what svg uses)
    let startAngle = ((angle1 - 90) * Math.PI) / 180;
    let endAngle = ((angle2 - 90) * Math.PI) / 180;

    //add a full revolution if the second angle is less than first
    if (endAngle < startAngle) endAngle += Math.PI * 2;

    const angleBetween = endAngle - startAngle > Math.PI ? 1 : 0; //now we use this 

    const radius = size * 0.45;
    const hand1 = getSecondPoint(cx, cy, radius - 7, angle1);
    const hand2 = getSecondPoint(cx, cy, radius - 7, angle2);
    const arcStart = getSecondPoint(cx, cy, radius, angle1);
    const arcEnd = getSecondPoint(cx, cy, radius, angle2);

    const fullCircle = ((hour1 ?? 0) % 12) === ((hour2 ?? 0) % 12);

    const hourMarks = [];
    for (let i = 0; i < 12; i++) {
        const inner = getSecondPoint(cx, cy, radius * 0.9, i * 30); //0.9 so its not coming straigh tfrom edge
        const outer = getSecondPoint(cx, cy, radius, i * 30);
        hourMarks.push(
            <line
                key={i}
                x1={inner.x}
                y1={inner.y}
                x2={outer.x}
                y2={outer.y}
                stroke="#000"
                strokeWidth={2}
            />
        );
    }

    return (
        <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}> {/*Start at 0 0 make a canvas size as it is defined in the component rendering*/}
            <circle
                cx={cx}
                cy={cy}
                r={radius}
                fill="none"
                stroke="#000"
                strokeWidth={3}
            />
            {hourMarks}
            <line
                x1={cx}
                y1={cy}
                x2={hand1.x}
                y2={hand1.y}
                stroke="#000000"
                strokeWidth={3}
                strokeLinecap="round"
            />
            <line
                x1={cx}
                y1={cy}
                x2={hand2.x}
                y2={hand2.y}
                stroke="#000000"
                strokeWidth={3}
                strokeLinecap="round"
            />
            {/* start at center go to the end of the first arrow, then make the arc*/}
            <path d={
                fullCircle
                    ? `M ${cx} ${cy} m -${radius} 0 a ${radius} ${radius} 0 1 0 ${radius * 2} 0 a ${radius} ${radius} 0 1 0 -${radius * 2} 0`
                    : `
                M ${cx} ${cy} 
                L ${arcStart.x} ${arcStart.y}
                A ${radius} ${radius} 0 ${angleBetween} 1 ${arcEnd.x} ${arcEnd.y}
                Z
                `} fill="#FF7A00" opacity={0.6} />
        </svg>
    );
}
